import { withRBAC } from "../rbac";
import { VendorBillCreate } from './VendorBillCreate';
import { VendorBillEdit } from './VendorBillEdit';
import { VendorBillList } from './VendorBillList';
import { VendorBillShow } from './VendorBillShow';

export const vendor_bills = {
    list: withRBAC(VendorBillList, "view_procurement"),
    show: withRBAC(VendorBillShow, "view_procurement"),
    create: withRBAC(VendorBillCreate, "manage_procurement"),
    edit: withRBAC(VendorBillEdit, "manage_procurement"),
};
